import { msg, str } from "@lit/localize";
export const getStatus = (statusCode) => {
    switch (statusCode) {
        case 'NewApplication':
            return msg(str`New Application`);
        case 'AwaitingResponse':
            return msg(str`Awaiting approval`);
        case 'Approved':
            return '';
        case 'ChangesRequested':
            return msg(str`Some changes have been requested, please check your email for details.`);
        case 'Rejected':
            return msg(str`Your application has been rejected, please contact support for more information.`);
        default:
            return '';
    }
}

export const getTier = (tier) => {
    switch (tier) {
        case 'Tier1':
            return msg(str`Taster`);
        case 'Tier2':
            return msg(str`Essential`);
        case 'Tier3':
            return msg(str`Plus`);
        default:
            return '';
    }
}

export const getRole = (role) => {
    switch (role) {
        case 'ADMIN':
            return msg(str`Primary admin`);
        case 'MANAGER':
            return msg(str`Admin`);
        case 'CULTURAL_MANAGER':
            return msg(str`Access Coordinator`);
        case 'TEAM_MEMBER':
            return msg(str`Access coordinator`);
        default:
            return '';
    }
}

export const getInviteStatus = (status) => {
    switch (status) {
        case 'Invited':
            return 'Pending - invite sent';
        case 'Accepted':
            return 'Accepted';
        case 'Rejected':
            return 'Rejected';
        default:
            return '';
    }
}